import { useLogger } from '@omnia/ui/src/lib/hooks/useLogger'
import { observer } from 'mobx-react-lite'
import type { FC } from 'react'
import { useSubscriptionNotifications } from '@/common/hooks/useSubscriptionNotifications'
import { useAvailableRewards } from '@/features/members-area/reward-store/hooks/useAvailableRewards'

export const NotificationsCount: FC = observer(() => {
    const logger = useLogger('NotificationCount')

    const { numberOfRewards, hasRewards } = useAvailableRewards({ hideRewardTypes: [] }, logger)
    const { notificationsCount, hasNotifications } = useSubscriptionNotifications()

    if (!hasRewards && !hasNotifications) {
        return
    }

    const count = numberOfRewards + notificationsCount
    return <div className="notifications-count">{count}</div>
})
